var _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRemoveFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32.21,44.71a2.79,2.79,0,0,1-1.16-.25l-8.81-4-8.82,4a2.85,2.85,0,0,1-4-2.9l1-9.61L4,24.79a2.85,2.85,0,0,1,1.53-4.7l9.46-2,4.81-8.38a2.85,2.85,0,0,1,4.94,0l4.81,8.38,9.45,2a2.84,2.84,0,0,1,1.53,4.7L34,32l1,9.61a2.85,2.85,0,0,1-2.84,3.15ZM21.77,40.3Zm.94,0ZM8.29,23.59l5.48,6.06a2.85,2.85,0,0,1,.72,2.21L13.61,40l7.46-3.34a2.81,2.81,0,0,1,2.34,0L30.86,40,30,31.87a2.9,2.9,0,0,1,.72-2.22l5.49-6.06-8-1.68a2.81,2.81,0,0,1-1.89-1.38l-4.06-7.07-4.07,7.08a2.83,2.83,0,0,1-1.9,1.37ZM38.15,24h0ZM6.94,22.1h0Zm7.76-3.55h0Zm15.07,0h0ZM15.46,18h0ZM29,18h0Zm-7.76-6.29h0Zm2,0h0Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,12.44H32a2,2,0,1,1,0-4H43.13a2,2,0,0,1,0,4Z",
    fill: outlineColor
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemoveFavorite);
export default __webpack_public_path__ + "static/media/ico-remove-favorite.797827bc323d58911e776179bdb4c0b8.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;